import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentData, GeneralData } from '../../document.interface';
import { EditContinutDocumentComponent } from './edit-continut-document/edit-continut-document.component';
import { DashboardService } from '../../dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { ToastService } from 'src/app/services/toast.service';
import { EditObservatiiDocumentComponent } from './edit-observatii-document/edit-observatii-document.component';
import { EditEmitentExternComponent } from './edit-emitent-extern/edit-emitent-extern.component';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-subsemnatul',
    templateUrl: './subsemnatul.component.html',
    styleUrls: ['./subsemnatul.component.scss'],
})
export class SubsemnatulComponent {
    @Input() data!: DocumentData;
    @Input() currentUser!: any;
    @Input() generalData!: GeneralData[];
    @Output() docChanged: EventEmitter<void> = new EventEmitter();

    helper = helper;

    constructor(
        public dashboardService: DashboardService,
        public dialog: MatDialog,
        private toastService: ToastService,
        public permissionsService: PermissionsService,
    ) { }

    openEditContinutDocument() {
        const dialogRef = this.dialog.open(EditContinutDocumentComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                docData: this.data,
                generalData: this.generalData,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.docChanged.emit();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Emitent/Destinatar - Documentație actualizată cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openEditObservatiiDocument() {
        const dialogRef = this.dialog.open(EditObservatiiDocumentComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                docData: this.data,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.docChanged.emit();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Observații documentație actualizate cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openEditEmitentExtern() {
        const dialogRef = this.dialog.open(EditEmitentExternComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                docData: this.data,
                generalData: this.generalData,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.docChanged.emit();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Emitent Extern - Documentație actualizată cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }
}
